exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-513e8bfa]{color:#9696a8;font-family:Montserrat;font-size:14px;font-weight:700;line-height:17px}", ""]);

// exports
